export default __webpack_public_path__ + "static/media/DashAppraisal.854db44d.svg";